import CustomSectionsType from './CustomSections.type';

const initialState = {
  customSectionList: [],
  customColumnList: null,
  editColumnData: null,
  dynamicColArr: [],
  measurementArr: [],
  sampleTrackingDates: [],
  currSectionList: [],
  bomTypes: [],

  // Range Plan Custom Sections State
  customSections: [],

  // Section-wise columns mapping (sectionId -> columns)
  sectionWiseColumns: {},

  gradingGroupList: [],
};

const ProductListReducer = (state = initialState, action) => {
  switch (action.type) {
    case CustomSectionsType.SET_CUSTOM_SECTION_LIST:
      return {
        ...state,
        customSectionList: action.payload,
      };
    case CustomSectionsType.SET_CUSTOM_SECTION_COLUMNS_LIST:
      return {
        ...state,
        customColumnList: action.payload,
      };
    case CustomSectionsType.SET_EDIT_COLUMN_DATA:
      return {
        ...state,
        editColumnData: action.payload,
      };
    case CustomSectionsType.SET_CUSTOM_SECTION_DYNAMIC_COLUMNS:
      return {
        ...state,
        dynamicColArr: action.payload,
      };
    case CustomSectionsType.SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS:
      return {
        ...state,
        measurementArr: action.payload,
      };
    case CustomSectionsType.SET_ALL_CUSTOM_SAMPLES_TRACKING:
      return {
        ...state,
        sampleTrackingDates: action.payload,
      };
    case CustomSectionsType.SET_SECTIONS_WITH_COLUMNS:
      return {
        ...state,
        currSectionList: action.payload,
      };
    case CustomSectionsType.UNMOUNT_CUSTOM_MODAL:
      return {
        ...state,
        editColumnData: null,
      };
    case CustomSectionsType.CUSTOM_SECTION_BOM_ALL_TYPES:
      return {
        ...state,
        bomTypes: action.payload,
      };
    case CustomSectionsType.SET_GRADING_GROUP_LIST:
      return {
        ...state,
        gradingGroupList: action.payload ?? [],
      };

    // Range Plan Custom Sections Cases
    case CustomSectionsType.SET_RANGEPLAN_CUSTOM_SECTIONS:
      return {
        ...state,
        customSections: action.payload,
      };

    case CustomSectionsType.ADD_RANGEPLAN_CUSTOM_SECTION:
      return {
        ...state,
        customSections: [...state.customSections, action.payload],
      };

    case CustomSectionsType.UPDATE_RANGEPLAN_CUSTOM_SECTION:
      const { sectionIndex, sectionId, updatedData } = action.payload;

      return {
        ...state,
        customSections: state.customSections.map((section, index) => {
          // Handle update by index (preferred for local state management)
          if (typeof sectionIndex === 'number' && index === sectionIndex) {
            return {
              ...section,
              ...updatedData,
            };
          }
          // Handle update by ID (for server responses)
          if (sectionId && section._id === sectionId) {
            return {
              ...section,
              ...updatedData,
            };
          }
          return section;
        }),
      };

    case CustomSectionsType.DELETE_RANGEPLAN_CUSTOM_SECTION:
      return {
        ...state,
        customSections: state.customSections.filter((section, index) => {
          if (action.payload.sectionId) {
            return section._id !== action.payload.sectionId;
          }
          if (typeof action.payload.sectionIndex === 'number') {
            return index !== action.payload.sectionIndex;
          }
          return true;
        }),
      };

    case CustomSectionsType.TOGGLE_SECTION_EDITING:
      return {
        ...state,
        customSections: state.customSections.map((section, index) =>
          index === action.payload.sectionIndex ? { ...section, isEditing: !section.isEditing } : section,
        ),
      };

    case CustomSectionsType.SET_SECTION_EDITING_STATE:
      return {
        ...state,
        customSections: state.customSections.map((section, index) =>
          index === action.payload.sectionIndex ? { ...section, isEditing: action.payload.isEditing } : section,
        ),
      };

    case CustomSectionsType.CLEAR_CUSTOM_SECTIONS_DATA:
      return {
        ...state,
        customSections: [],
        sectionWiseColumns: {}, // Clear section-wise columns when clearing sections
      };

    case CustomSectionsType.SET_SECTION_WISE_COLUMNS:
      return {
        ...state,
        sectionWiseColumns: {
          ...state.sectionWiseColumns,
          [action.payload.sectionId]: action.payload.columns,
        },
      };

    default:
      return state;
  }
};
export default ProductListReducer;
